import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router'

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchAutoCompleteSuggestions: any;
  faSearch = faSearch;
  tickerValue: string;
  enterStockTickerMessageDisplay = "none";

  onSearchBoxTextChange(event: any) {
    const typedText = event.target.value;
    if (typedText !== undefined && typedText !== null && typedText.length > 0)
      this.searchService.getSearchAutoCompleteSuggestions(typedText).subscribe(searchResults => {
        this.searchAutoCompleteSuggestions = searchResults.map(searchResult => { return { "ticker": searchResult["ticker"], "name": searchResult["name"] } })
      })
  }

  searchclick(event: any) {
    event.preventDefault();
    if (this.tickerValue === undefined || this.tickerValue === null || this.tickerValue.trim().length === 0) {
      this.enterStockTickerMessageDisplay = "inline";
      setTimeout(() => {
        this.enterStockTickerMessageDisplay = "none";
      }, 2000);
    } else
      this.router.navigate(['/details/' + this.tickerValue]);
  }

  onStockSelected(searchBoxText: any) {
    this.tickerValue = searchBoxText.split("|")[0].trim();
  }

  constructor(private searchService: SearchService, private router: Router) {

  }

  ngOnInit(): void {
  }

}
